module.exports = __webpack_public_path__ + "static/media/Total-Body.c662dff0.jpeg";